/* eslint-disable */ 
// init Swiper:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

let swiper;

// Function to initialize Swiper
function initSwiper(direction = 'vertical') {
  if (swiper) swiper.destroy(true, true);

  swiper = new Swiper('.timeline .swiper-container', {
      direction,
      loop: true,
      modules: [Navigation, Pagination],
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
              const year =
                  document
                      .querySelectorAll('.swiper-slide')
                      [index]?.getAttribute('data-year') || '';
              return `<span class="${className}">${year}</span>`;
          },
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
  });
}

// Function to determine direction based on window size
function getDirection() {
  return window.innerWidth < 768 ? 'horizontal' : 'vertical';
}

// Watch for resize and reinit swiper if direction changes
let currentDirection = getDirection();
initSwiper(currentDirection);

window.addEventListener('resize', () => {
  const newDirection = getDirection();
  if (newDirection !== currentDirection) {
    currentDirection = newDirection;
    initSwiper(currentDirection);
  }
});
/* eslint-enable */ 
